// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"37":"postload","160":"components","330":"priority","351":"commons"}[chunkId] + ".chunk.B96CoriginmasterD20260128195241.js";
};